import { useState } from "react";

const CustomSwitch = ({
  size = "md",
  color = "primary",
  isChecked: controlledChecked,
  value,
  onChange,
  disabled = false,
  className = "",
  "aria-label": ariaLabel,
}) => {
  const [internalChecked, setInternalChecked] = useState(false);

  const isChecked =
    controlledChecked !== undefined
      ? controlledChecked
      : value !== undefined
        ? Boolean(value)
        : internalChecked;

  const handleToggle = () => {
    if (disabled) return;

    if (controlledChecked === undefined && value === undefined) {
      setInternalChecked(!internalChecked);
    }

    if (onChange) {
      onChange(!isChecked);
    }
  };

  // Size configurations
  const sizes = {
    sm: { width: 32, height: 18, thumb: 14, translate: 14 },
    md: { width: 44, height: 24, thumb: 20, translate: 20 },
    lg: { width: 56, height: 30, thumb: 26, translate: 26 },
  };

  // Color configurations
  const colors = {
    primary: {
      on: "bg-[#207C97]",
      off: "bg-gray-300",
      thumb: "bg-white",
    },
    success: {
      on: "bg-green-500 ",
      off: "bg-gray-300",
      thumb: "bg-white",
    },
    warning: {
      on: "bg-orange-500 ",
      off: "bg-gray-300",
      thumb: "bg-white",
    },
    danger: {
      on: "bg-red-500 ",
      off: "bg-gray-300",
      thumb: "bg-white",
    },
    purple: {
      on: "bg-purple-500 ",
      off: "bg-gray-300",
      thumb: "bg-white",
    },
  };

  const sizeConfig = sizes[size];
  const colorConfig = colors[color];

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={handleToggle}
      disabled={disabled}
      className={`
        relative inline-flex items-center rounded-full
        transition-all duration-300 ease-in-out
        focus:outline-none 
        ${isChecked ? colorConfig.on : colorConfig.off}
        
        ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:shadow-lg"
        }
        ${className}
      `}
      style={{
        width: sizeConfig.width,
        height: sizeConfig.height,
      }}
    >
      <span
        className={`
          inline-block rounded-full transform transition-all duration-300 ease-in-out
          ${colorConfig.thumb}
          ${disabled ? "" : "hover:scale-110"}
        `}
        style={{
          width: sizeConfig.thumb,
          height: sizeConfig.thumb,
          transform: `translateX(${isChecked ? sizeConfig.translate : 2}px)`,
        }}
      />
    </button>
  );
};

export default CustomSwitch;
